import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'

type Theme = 'light' | 'dark'

interface ThemeContextProps {
  theme: Theme
  toggleTheme: () => void
}

const defaultContextData: ThemeContextProps = {
  theme: 'light', // eslint-disable-next-line @typescript-eslint/no-empty-function
  toggleTheme: () => {},
}

const ThemeConfig = createContext<ThemeContextProps>(defaultContextData)

interface ThemeProviderProps {
  children: ReactNode
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [theme, setTheme] = useState<Theme>('light')

  useEffect(() => {
    const userPrefersDark =
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches
    setTheme(userPrefersDark ? 'dark' : 'light')
  }, [])

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'))
  }

  return (
    <ThemeConfig.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeConfig.Provider>
  )
}

export const useTheme = () => useContext(ThemeConfig)
